
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import EditCollectionForm from "@/components/forms/EditCollectionForm";
import { useCollections } from "@/contexts/collections";
import { useEffect } from "react";

// No props needed since we use the context internally
const EditCollectionDialog = () => {
  const { operation, closeOperation, handleCollectionUpdated } = useCollections();
  
  const isOpen = operation.isOpen && operation.type === "edit";
  const collection = operation.collection;

  // Log dialog state for debugging
  useEffect(() => {
    console.log("Edit dialog state:", { isOpen, collection });
  }, [isOpen, collection]);

  if (!collection) {
    return null;
  }

  const handleComplete = () => {
    console.log('[EditCollectionDialog] handleComplete called');
    closeOperation();
    handleCollectionUpdated();
    
    // TEMPORARY FIX: Force page refresh after dialog closes
    setTimeout(() => {
      console.log('[EditCollectionDialog] Forcing page refresh');
      window.location.reload();
    }, 100);
  };

  const handleOpenChange = (open: boolean) => {
    console.log('[EditCollectionDialog] handleOpenChange called with:', open);
    if (!open) {
      closeOperation();
      
      // TEMPORARY FIX: Force page refresh when dialog is closed
      setTimeout(() => {
        console.log('[EditCollectionDialog] Forcing page refresh after dialog close');
        window.location.reload();
      }, 100);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleOpenChange}>
      <DialogContent className="sm:max-w-[550px]">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold">Edit Collection</DialogTitle>
          <DialogDescription>
            Update your collection details below
          </DialogDescription>
        </DialogHeader>
        <EditCollectionForm
          collectionId={collection.id}
          initialName={collection.name}
          initialDescription={collection.description || ""}
          initialColor={collection.color || undefined}
          onComplete={handleComplete}
        />
      </DialogContent>
    </Dialog>
  );
};

export default EditCollectionDialog;
